/**
 * Link vertical (and horizontal) scroll across jsoneditor tree/view panes.
 * Uses scroll ratio so panes with different row heights stay roughly aligned.
 */

function scrollRatio(el, axis) {
  const size = axis === 'x' ? 'clientWidth' : 'clientHeight';
  const scroll = axis === 'x' ? 'scrollWidth' : 'scrollHeight';
  const pos = axis === 'x' ? 'scrollLeft' : 'scrollTop';
  const max = el[scroll] - el[size];
  return max > 0 ? el[pos] / max : 0;
}

function setScrollRatio(el, axis, ratio) {
  const size = axis === 'x' ? 'clientWidth' : 'clientHeight';
  const scroll = axis === 'x' ? 'scrollWidth' : 'scrollHeight';
  const pos = axis === 'x' ? 'scrollLeft' : 'scrollTop';
  const max = el[scroll] - el[size];
  el[pos] = ratio * max;
}

/**
 * @param {HTMLElement[]} elements scroll containers (e.g. .jsoneditor-outer)
 * @returns {{ detach: () => void }}
 */
export function linkJsonEditorScroll(elements) {
  const panes = elements.filter(Boolean);
  if (panes.length < 2) {
    return { detach: () => {} };
  }

  let syncing = false;
  const listeners = [];

  function propagate(source, axis) {
    if (syncing) return;
    syncing = true;
    const ratio = scrollRatio(source, axis);
    panes.forEach(el => {
      if (el !== source) setScrollRatio(el, axis, ratio);
    });
    syncing = false;
  }

  panes.forEach(el => {
    const onScroll = () => {
      propagate(el, 'y');
      propagate(el, 'x');
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    listeners.push({ el, onScroll });
  });

  return {
    detach() {
      listeners.forEach(({ el, onScroll }) => {
        el.removeEventListener('scroll', onScroll);
      });
    }
  };
}

/**
 * Resolve scroll element inside a vue-json-editor component instance or DOM root.
 * @param {Vue|HTMLElement|null} root
 * @returns {HTMLElement|null}
 */
export function getJsonEditorScrollElement(root) {
  if (!root) return null;
  const el = root.$el || root;
  if (!el || !el.querySelector) return null;
  return el.querySelector('.jsoneditor-outer');
}
